(function cardgridScript($, Drupal) {
    Drupal.behaviors.cardgrid = {
        attach: function (context, settings) {
            $('.card-teaser__type').each(function () {
                var recipeNames = $(this).text();
                if (recipeNames) {
                    $(this).text(recipeNames.trim().split(/(?=[A-Z])/).join(' '));
                }
            });
        },
    };
}(jQuery, Drupal));
